import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { unregister } from './serviceWorker'
import Firebase, { FirebaseContext } from './components/Fb'
import { CookiesProvider } from 'react-cookie'
// Material Symbols Rounded - the sidebar icon font (route.symbol in routes.js).
import 'material-symbols/rounded.css'

if (process.env.NODE_ENV !== 'development') {
  console.log = () => {}
  console.warn = () => {}
  console.error = () => {}
}

const rootNode = document.getElementById('root')
const root = createRoot(rootNode)

root.render(
  <StrictMode>
    <CookiesProvider>
      <FirebaseContext.Provider value={new Firebase()}>
        <App />
      </FirebaseContext.Provider>
    </CookiesProvider>
  </StrictMode>
)
unregister()
